import axios from 'axios';
import {
  Message
} from 'element-ui'
import {
  getCookie,
  delCookie
} from '../utils/util'
import router from '../router'
// axios.defaults.baseURL = 'http://192.168.0.117:7301';
axios.defaults.baseURL = 'http://47.121.135.35:7301';
// 通用公用方法
const req = (method, url, params) => {
  return axios({
      method: method,
      url: url,
      data: params,
    })
    .then(res => {
      if (res.data.code != 200) {
        Message({
          message: res.data.msg,
          type: 'error'
        })
      }
      return res.data
    })
    .catch(error => {
      return error
    });
};

export {
  loginreq,
  req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js